import React, { FC, useEffect } from 'react';
import s from './SuccessFeedback.module.css'
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store/hooks/hooks';
import { toggleSuccessModal } from '../../store/slices/infoSlice';

const SuccessFeedback: FC = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(toggleSuccessModal(false))
        }, 3000)

        return () => clearTimeout(timer)
    }, [dispatch])
    return (
        <div className={`${s.wrapper} animate__animated animate__fadeIn animate__faster`}>
            <div className={s.container}>
                <p className={s.thanks}>{t("home.feedbacks.success")}</p>
            </div>
        </div>
    );
};

export default SuccessFeedback;